
import { controls } from "../controls";


const tr027details = {
    label: "BC Entry Details",
    pageLabel: "BC Entry Details",
    starting: true,
    url: "tr027details",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    form: [
        ...controls.displayText({ label: "Drawer", width: "col-sm-2" }),
        ...controls.text({ width: "col-sm-2", placeHolder: "Drawer", name: "drawer" }),
        ...controls.displayText({ width: "col-sm-2" }),
        ...controls.displayText({ label: "Drawee Bank", width: "col-sm-2" }),
        ...controls.numberOnly({ width: "col-sm-2", name: "drawee_bank", placeHolder: "Drawee Bank" }),
        ...controls.displayText({ width: "col-sm-2" }),
        ...controls.displayText({ label: "Sent To Bank", width: "col-sm-2" }),
        ...controls.showData({ width: "col-sm-3", data: "sent_to_bank" }),
        ...controls.displayText({ width: "col-sm-1" }),
        ...controls.displayText({ label: "Sent General Lendger", width: "col-sm-2", star: true }),
        ...controls.GL({ width: "col-sm-2", isRequired: true }),
        ...controls.showData({ data: "gl_code_display", name: "gl_code_display", width: "col-sm-2" }),
        ...controls.displayText({ label: "Sent Account No", width: "col-sm-2" }),
        ...controls.AccountNumber({
          forceRender: true,
          beforeLeave: ["createAcNo"],
          width: "col-sm-2",
          onLeave: ["checkPAN", "checkMobile", "checkSMS", "checkAADHAAR", "checkLoans", "checkAcClosed","checkMinBal","checkRenewal","checkPremature"], // {type:'check',value:'pan'},{type:'match',value:12000}, 
        }),
        ...controls.displayText({ width: "col-sm-2" }),
        ...controls.displayText({ label: "Our Commission", width: "col-sm-2" }),
        ...controls.numberOnly({ width: "col-sm-2", name: "our_commission", placeHolder: "Our Commission" }),
        ...controls.displayText({ width: "col-sm-2" }),
        ...controls.displayText({ label: "Their Commission", width: "col-sm-2" }),
        ...controls.numberOnly({ width: "col-sm-2", name: "their_commission", placeHolder: "Their Commission" }),
        ...controls.displayText({ width: "col-sm-2" }),
        ...controls.displayText({ label: "GST On Our Comm", width: "col-sm-2 " }),
        ...controls.numberOnly({ width: "col-sm-2", name: "gst", placeHolder: "GST" }),
        ...controls.displayText({ width: "col-sm-2" }),
        ...controls.displayText({ label: "Postage", width: "col-sm-2",}),
        ...controls.text({ width: "col-sm-2", name: "postage", placeHolder: "Postage",  }),
        ...controls.displayText({ width: "col-sm-2" }),
        
        ...controls.displayText({ width: "col-sm-2", label: "Address" }),
        ...controls.text({ width: "col-sm-2",name:"address",placeHolder:"Address" }),
        



    ]
}

export default tr027details;